import { useEffect, useState } from 'react';
import Layout from '../../../Components/Layout/Layout';
import Form from 'react-bootstrap/Form';
import { Col, Row } from 'react-bootstrap';
import CompanyProfile from '../RegistrationComponents/CompanyProfile';
import ContactPerson from '../RegistrationComponents/ContactPerson';
import PortalLogin from '../RegistrationComponents/PortalLogin';
import { useForm } from 'react-hook-form';
import Toaster from '../../../Components/Toaster/Toaster';
import { useExhibitorAuthContext } from '../../../Context/AuthContex/ExhibitorAuthContext';
import { EXHIBITOR_USER_SUCCESS } from '../../../Helpers/Constant';
import { useNavigate } from 'react-router-dom';
import { httpService } from '../../../Helpers/Fetcher/axios';
import ToabMemberSearchByName from '../../Common/ToabMemberSearchByName';
import { ICompanyProfileInfoRegister } from '../../../Types/RegisterTypes';
import OnlyRegistrationOTP from '../../../Components/Common/CheckPreviousRegistration/OnlyRegistrationOTP';
import { useCheckPreviousRegistration } from '../../../Components/Common/apiEndpoints/commApiEndpoints';

const ExhibitorRegistration = () => {
  const { dispatch: authDispatch, setIsLoading } = useExhibitorAuthContext();
  const {
    mutate,
    isSuccess: otpSuccess,
    isPending,
  } = useCheckPreviousRegistration();
  const [registrationData, setRegistrationData] = useState<any>({});
  const Toast = Toaster();
  const navigate = useNavigate();
  const [toggleButton, setToggleButton] = useState('');
  const [memberData, setMemberData] =
    useState<ICompanyProfileInfoRegister | null>();
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    resetField,
    setValue,
    reset,
    formState: { errors },
    watch,
  } = useForm();
  useEffect(() => {
    if (errors) {
      const file1 = errors['user_fair_member_company_logo']?.message;
      if (file1) {
        Toast.fire({
          icon: 'error',
          title: `File is required`,
        });
      }
    }
  }, [errors, Toast]);
  const onSubmit = async (value: any) => {
    const { user_fair_member_confirm_password, ...data } = value || {};
    setIsLoading?.(true);
    if (data?.user_fair_member_password !== user_fair_member_confirm_password) {
      Toast.fire({
        icon: 'error',
        title: `Password does not match`,
      });
      setIsLoading?.(false);
      return;
    }
    if (data?.user_fair_member_password?.length < 8) {
      Toast.fire({
        icon: 'error',
        title: `Password must be at least 8 characters`,
      });
      setIsLoading?.(false);
      return;
    }

    if (data?.user_fair_member_password?.length > 16) {
      Toast.fire({
        icon: 'error',
        title: `Maximum password length is 16 characters`,
      });

      return;
    }
    setRegistrationData(data);
    mutate({
      email: data?.user_fair_member_company_email,
      type: 'register_fair',
    });
  };

  const handleRegistration = async (value: boolean) => {
    if (value) {
      const formData = new FormData();
      Object.keys(registrationData).forEach((key) => {
        if (typeof registrationData[key] === 'object') {
          if (registrationData[key] instanceof Blob) {
            formData.append(key, registrationData[key]);
          } else {
            formData.append(key, registrationData[key][0]);
          }
        } else {
          formData.append(key, registrationData[key]);
        }
      });

      try {
        const res = await httpService.post({
          url: `/api/auth/fair-member/register`,
          data: formData,
        });

        if (res.success) {
          Toast.fire({
            icon: 'success',
            title: `Successfully register`,
          });
          authDispatch?.({
            type: EXHIBITOR_USER_SUCCESS,
            payload: { ...(res?.data as any), token: res.token },
          });

          localStorage.setItem('toab_exibitor_token', res?.token as string);
          reset();
          setIsLoading?.(false);
          navigate('/profile');
        } else {
          Toast.fire({
            icon: 'error',
            title: res.message,
          });
        }
      } catch (error) {
        Toast.fire({
          icon: 'error',
          title: 'Something went wrong',
        });
      } finally {
        setIsLoading?.(false);
      }
    }
  };

  return (
    <Layout pathName={'Book your space'} showHeader>
      {Object?.keys(registrationData)?.length && otpSuccess ? (
        <OnlyRegistrationOTP
          email={registrationData?.user_fair_member_email}
          handleRegistration={handleRegistration}
          type='register_fair'
        />
      ) : (
        <div>
          <div className='container'>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className='register-top'>
                <div className='register-top-div'>
                  <h3>TOAB Membership </h3>
                </div>
                <div className='register-top-form-card '>
                  <Row className='d-block d-md-flex align-items-center'>
                    <Col sx={12} md={12} lg={4} className='pb-2 pb-md-0'>
                      <div className='d-block d-md-flex gap-4'>
                        <div className='d-flex align-items-center gap-3 ps-0 ps-md-3 '>
                          <label htmlFor=''>
                            TOAB Member <span style={{ color: 'red' }}>*</span>
                          </label>
                          <Form.Check
                            type='radio'
                            aria-label='radio 1'
                            name='yes'
                            label='Yes'
                            onClick={() => setToggleButton('yes')}
                          />
                          <Form.Check
                            type='radio'
                            name='yes'
                            aria-label='radio 1'
                            label='No'
                            onClick={() => {
                              setToggleButton('no');
                              setMemberData(null);
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    {toggleButton === 'yes' && (
                      <Col xs={12} md={6}>
                        <Row className='g-1'>
                          <>
                            <Col xs={12} md={8} lg={6}>
                              Organization Name
                              <span style={{ color: 'red' }}>*</span>
                              <ToabMemberSearchByName
                                onChange={(v) => setMemberData(v)}
                                placeholder='TOAB Member'
                              />
                            </Col>
                          </>
                        </Row>
                      </Col>
                    )}
                  </Row>
                </div>
              </div>

              <div
                className={
                  toggleButton === 'no' || memberData?.email
                    ? ''
                    : 'parent-register'
                }
              >
                <div
                  className={
                    toggleButton === 'no' || memberData?.email
                      ? ''
                      : 'child-register'
                  }
                >
                  <div>
                    <CompanyProfile
                      register={register}
                      setError={setError}
                      clearErrors={clearErrors}
                      setValue={setValue}
                      resetField={resetField}
                      errors={errors}
                      companyProfileReg={memberData}
                    />
                  </div>

                  <div>
                    <ContactPerson register={register} />
                  </div>
                  <div>
                    <PortalLogin
                      loading={isPending}
                      watch={watch}
                      register={register}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default ExhibitorRegistration;
